module.exports = __webpack_public_path__ + "img/Cameron_Mccree.621231b8.jpeg";